import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit';

export interface IPageCountProps {
  baseName: string;
  readOnly: boolean;
}

export const PageCount: React.FC<IPageCountProps> = ({ baseName, readOnly }) => {
  return (
    <NumberField
      name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.PageCount}`}
      label={'Page Count'}
      placeholder={'0'}
      mode={'default'}
      readOnly={readOnly}
    />
  );
};
